"use strict";
import 'owl.carousel';

var Testimonials = function() {

    return {
        init: function() {
            var carousels = $("[data-owl='testimonials']");

            var carouselResponsiveOptions1 = {
                stagePadding: 0,
                dots: true,
                dotsEach: 1,
                nav: true,
                loop: false,
                rewind: false,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 0,
                        margin: 20,
                        nav: false
                    },
                    600: {
                        items: 2,
                        margin: 20,
                        stagePadding: 0
                    },
                    900: {
                        items: 3,
                        stagePadding: 0,
                        margin: 20
                    },
                    1200: {
                        items: 3,
                        stagePadding: 0,
                        margin: 20
                    }
                }
            };

            var carouselResponsiveOptions2 = {
                stagePadding: 0,
                loop: false,
                rewind: false,
                nav: true,
                margin: 20,
                items: 1,
                dotsEach: 1,
                responsive: {
                    0: {
                        nav: false
                    },
                    600: {
                        nav: true
                    },
                    900: {
                        nav: true
                    },
                    1200: {
                        nav: true
                    }
                }
            };

            if (carousels.length) {

                for (let i = 0; i < carousels.length; i++) {
                    let carousel = $(carousels[i]),
                        numberOfCards = $(carousel).find('.owl-item').length,
                        isColumn50Percent = (carousel.closest('.column.medium-6').length > 0),
                        options = !isColumn50Percent ? carouselResponsiveOptions1 : carouselResponsiveOptions2;

                    if (numberOfCards > 1) {
                        carousel.owlCarousel(options);
                    }
                    else {
                        let caourselContainer = carousel.closest('.testimonial-cards');
                        $(caourselContainer).addClass('testimonial-cards__grid__edit');
                    }

                }

                const icon = `<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="/dist/svgsprite/icons.svg#Arrow_16x16"></use></svg>`;

                $('button.owl-next span, button.owl-prev span').html(icon);
            }
        }
    };

};

document.addEventListener("DOMContentLoaded", function () {
    const testimonials = new Testimonials();
    testimonials.init();
});